import React from 'react';
import { Award, Gauge, ShieldCheck, Truck } from 'lucide-react';
import { trustItems } from '../data/mock';

const icons = { Award, Gauge, ShieldCheck, Truck };

const TrustItem = ({ item }) => {
  const Icon = icons[item.icon];
  return (
    <div className="flex items-center gap-4 px-6 py-5" data-testid={`trust-item-${item.icon.toLowerCase()}`}>
      <div className="w-12 h-12 rounded-lg bg-[#FF6B00]/15 flex items-center justify-center flex-shrink-0">
        <Icon className="text-[#FF6B00]" size={26} />
      </div>
      <span className="text-white font-semibold text-sm md:text-base leading-snug">{item.text}</span>
    </div>
  );
};

const TrustBar = () => (
  <section className="bg-[#111111] border-y border-[#2a2a2a]" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-2 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 divide-[#2a2a2a]">
      {trustItems.map((item) => <TrustItem key={item.icon} item={item} />)}
    </div>
  </section>
);

export default TrustBar;
